<!-- eslint-disable implicit-arrow-linebreak -->
<template>
  <div v-if="isNavVisible" class="nav-menu-container">
    <div v-for="item in navItems" :key="item.key">
      <NavItem
        :linkText="item.linkText"
        :linkRouteName="item.linkRouteName"
        :isSelected="item.isSelected"
        :linkId="item.key"
        ></NavItem>
        <span class="divider" v-if=isDividerVisible(item.key)>|</span>
    </div>
    <div class="exit-button">
      <font-awesome-icon
        :icon="['fas', 'right-from-bracket']"
        aria-label="Logoff"
        title="LOGOFF"
        @click="onExitClicked"/>
    </div>
  </div>
</template>

<script setup>
import {
  computed, watch, onMounted, reactive,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import NavItem from './NavItem.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

const allNavItems = [
  {
    key: 0,
    linkText: 'Home',
    linkRouteName: 'home',
    isSelected: true,
    validRoles: ['3B0DFFAE-FF08-425D-824D-859F6917B98E',
      '052632C0-EACD-4655-B8CC-C99F1CBA32BC',
      'B305332E-FC85-4C82-82AE-D57A70E0F0A7'],
  },
  {
    key: 1,
    linkText: 'Resource Center',
    linkRouteName: 'resources',
    isSelected: false,
    validRoles: ['3B0DFFAE-FF08-425D-824D-859F6917B98E',
      '052632C0-EACD-4655-B8CC-C99F1CBA32BC',
      '37430222-7D42-4132-92E5-F1082FC3FD35'],
  },
];

const role = computed(() => store.getters['userStore/role']);

// eslint-disable-next-line max-len
const navItems = reactive([]);

function setNavItems() {
  navItems.length = 0;
  navItems.push(...allNavItems.filter((item) => item.validRoles.includes(role.value?.toUpperCase() ?? '')));
}

const isNavVisible = computed(() => {
  if (navItems && navItems.length > 0) {
    return true;
  }
  return false;
});

const lastKey = computed(() => {
  if (isNavVisible.value) {
    return navItems[navItems.length - 1].key;
  }
  return 0;
});

function isDividerVisible(key) {
  if (key === lastKey.value) {
    return false;
  }
  return true;
}

function onMenuChanged(arg) {
  for (let i = 0; i < navItems.length; i += 1) {
    navItems[i].isSelected = (navItems[i].key === arg);
  }
}

function setRouteName(routeName) {
  const navitem = navItems.find((item) => item.linkRouteName === routeName.toLowerCase());

  if (navitem) {
    onMenuChanged(navitem.key);
  }
}

function onExitClicked() {
  router.push({ name: 'logout' });
}

watch(() => route.name, (newRouteName) => {
  setRouteName(newRouteName);
});

onMounted(() => {
  const routeName = route.name ?? 'home';
  setNavItems();
  setRouteName(routeName);
});
</script>

<style>
  .nav-menu-container {
    padding-top: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
    display: flex;
  }

  .nav-menu-container > :last-child  {
    margin-left: auto;
  }

  .exit-button {
    color: #324047;
    cursor: pointer;
  }

  .divider {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media only screen and (max-width: 880px) {
    .nav-menu-container {
      padding-top: 3rem;
      padding-left: 1rem;
    }
  }
</style>
